import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { DEL_CIRCULAR_ACTION_TYPE, GET_CIRCULAR_COMPANY_ACTION_TYPE, GET_CIRCULAR_LIST_ACTION_TYPE, INSERT_CIRCULAR_ACTION_TYPE, deleteCircularUrl, getCircularCompantUrl, getCircularListUrl, headers, insertCircularUrl, user_id, award_event_id, assignCircularUrl, ASSIGN_CIRCULAR_ACTION_TYPE } from "../../utils/constants";


export const getCircularCompany_action = (application_no, payment_type, company_name, user_type) => async (dispatch) => {
    try {
        const params = {
            UserId: sessionStorage.getItem('user_id'),
            award_event_id: sessionStorage.getItem("award_event_id"),
            application_no: application_no,
            payment_type: payment_type,
            company_name: company_name,
            user_type: user_type,
        }
         const res = await axiosGet(getCircularCompantUrl, params, headers)

        dispatch({
            type: GET_CIRCULAR_COMPANY_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getCircularList_action = () => async (dispatch) => {
    try {
        const params = {
            UserId: user_id,
            award_event_id: sessionStorage.getItem("award_event_id"),
        }
        const res = await axiosGet(getCircularListUrl, params, headers)

        dispatch({
            type: GET_CIRCULAR_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertCicular_action = (circularDate, circularTitle, circularFile, list, circularFileType, isSendMail, Content) => async (dispatch) => {
    try {
        const mapData = {
            UserId: user_id,
            CircularID: null,
            CircularDate: circularDate,
            award_event_id: sessionStorage.getItem("award_event_id"),
            title: circularTitle,
            Attachment: circularFile,
            circularListData: list,
            AttachmentType: circularFileType,
            isSendMail: isSendMail,
            Content: Content,
        }
        const res = await axiosPost(insertCircularUrl, mapData, headers)

        dispatch({
            type: INSERT_CIRCULAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const delCircular_action = (circularId) => async (dispatch) => {
    try {
        const params = {
            UserID: user_id,
            CircularID: circularId,
        }
        const res = await axiosGet(deleteCircularUrl, params, headers)

        dispatch({
            type: DEL_CIRCULAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const assignCircular_action = (circularListData, isSendMail) => async (dispatch) => {
    try {
        const params = {
            UserID: user_id,
            award_event_id: sessionStorage.getItem("award_event_id"),
            circularListData: circularListData,
            isSendMail: isSendMail,
        }
        const res = await axiosPost(assignCircularUrl, params, headers)

        dispatch({
            type: ASSIGN_CIRCULAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}